export var InsuranceName;
(function (InsuranceName) {
    InsuranceName["None"] = "NONE";
    InsuranceName["Normal"] = "NORMAL";
    InsuranceName["Perfect"] = "PERFECT";
    InsuranceName["Super"] = "SUPER";
})(InsuranceName || (InsuranceName = {}));
